export enum EventAction {
  ACTION_ADD = 'ACTION_ADD',
  ACTION_EDIT = 'ACTION_EDIT',
  ACTION_DELETE = 'ACTION_DELETE',
}
